import {REGIONS, STAGE} from './constants';

const BASE_URL_STAGE_REGION_MAP = new Map();
// "STAGE-REGION" => url
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.BETA}-${REGIONS.NA}`, "https://dolphin.amazon.com");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.BETA}-${REGIONS.EU}`, "https://dolphin.amazon.eu");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.BETA}-${REGIONS.IN}`, "https://dolphin.amazon.eu/in");

BASE_URL_STAGE_REGION_MAP.set(`${STAGE.GAMMA}-${REGIONS.NA}`, "https://dolphin-preprod.amazon.com");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.GAMMA}-${REGIONS.EU}`, "https://dolphin-preprod.amazon.eu");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.GAMMA}-${REGIONS.FE}`, "https://dolphin-fe-preprod.amazon.com");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.GAMMA}-${REGIONS.IN}`, "https://dolphin-preprod.amazon.eu/in");

BASE_URL_STAGE_REGION_MAP.set(`${STAGE.PROD}-${REGIONS.NA}`, "https://dolphin.amazon.com");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.PROD}-${REGIONS.EU}`, "https://dolphin.amazon.eu");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.PROD}-${REGIONS.FE}`, "https://dolphin-fe.amazon.com");
BASE_URL_STAGE_REGION_MAP.set(`${STAGE.PROD}-${REGIONS.IN}`, "https://dolphin.amazon.eu/in");

export function getBaseURL() {
    const stageRegion = `${getStage()}-${getRegion()}`;
    return BASE_URL_STAGE_REGION_MAP.has(stageRegion) ? BASE_URL_STAGE_REGION_MAP.get(stageRegion) : null;
}

export function getPandaTokenExchangeURL() {
    switch (getRegion()) {
        case REGIONS.NA:
            return "https://api.amazon.com/auth/token";
        case REGIONS.IN:
        case REGIONS.EU:
            return "https://api.amazon.co.uk/auth/token";
        case REGIONS.FE:
            return "https://api.amazon.co.jp/auth/token";
        // no default
    }
}

export function getRegion() {
    // TODO
    // const hostname = window.location.hostname;
    // if (hostname.startsWith('na')) return REGIONS.NA;
    // else if (hostname.startsWith('eu')) return REGIONS.EU;
    // else if (hostname.startsWith('fe')) return REGIONS.FE;
    // else if (hostname.startsWith('in')) return REGIONS.IN;
    return REGIONS.NA;
}

function getStage() {
    // TODO
    // const hostname = window.location.hostname.split('.');
    // if (hostname[1] != null) {
    //     const stage = hostname[1];
    //     if (stage.endsWith('integ')) return 'beta';
    //     else if (stage.endsWith('master')) return 'gamma';
    //     else if (stage.endsWith('prod')) return 'prod';
    //     return 'gamma';
    // }
    return STAGE.GAMMA;
}



// WEBPACK FOOTER //
// ./src/network/base/base-urls.js